module.exports = __webpack_public_path__ + "static/how-to-5-2112153ca26364482647655d16eefa29.webp";